import type { ICaseManager, IResponseBase } from '@/interfaces';
import { Http, HttpService } from './http';

const http = Http.create();

export class CaseManagerService extends HttpService {
	static async getManagers(caseId: string) {
		const response = await http.get<IResponseBase<ICaseManager[]>>(`/cases/${caseId}/managers`);
		return response.data;
	}

	static async assignManager(caseId: string, managerId: string) {
		const response = await http.post<IResponseBase<ICaseManager>>(`/cases/${caseId}/managers`, {
			managerId,
		});
		return response.data;
	}

	static async unassignManager(caseId: string, managerId: string) {
		const response = await http.delete<IResponseBase<null>>(
			`/cases/${caseId}/managers/${managerId}`,
		);
		return response.data;
	}
}
